import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import API, { showNetworkErrorToast } from "Utils/api";

import { RowData } from "Components/NewList/types";
import { reorderMissions, setMissions } from ".";

export const fetchMissions = createAsyncThunk<
  void,
  {
    currentFleetId: string;
  }
>(
  "fetchMissions",
  async (
    data: {
      currentFleetId: string;
    },
    thunkAPI
  ) => {
    try {
      const response = await API.get(
        `/fleets/mission_queue/?status=deployed&fleet_ids=${data.currentFleetId}`
      );
      thunkAPI.dispatch(setMissions(response?.data?.results));
    } catch (error) {
      showNetworkErrorToast(error);
      return Promise.reject();
    }
  }
);

export const cancelLiveAndQueueMission = createAsyncThunk<
  void,
  { missionId: string; vehicleId: string }
>(
  "missionPage/cancel",
  async (data: { missionId: string; vehicleId: string }) => {
    try {
      await API.post(
        `vehicles/${data.vehicleId}/mission_queue/${data.missionId}/cancel/`
      );
      toast.success("Mission cancelled successfully");
    } catch (error) {
      showNetworkErrorToast(error);
      return Promise.reject();
    }
  }
);

export const changeMissionOrder = createAsyncThunk<
  void,
  {
    missionId: string;
    order: number;
    cancelAction: () => RowData[];
    newMissionsOrder: RowData[];
  }
>(
  "missionQueue",
  async (
    data: {
      missionId: string;
      order: number;
      cancelAction: () => RowData[];
      newMissionsOrder: RowData[];
    },
    thunkAPI
  ) => {
    thunkAPI.dispatch(
      reorderMissions(data.newMissionsOrder.map((item) => item.id))
    );
    try {
      await API.patch(`fleets/mission_queue/${data.missionId}/`, {
        order: data.order,
      });
      toast.success("Mission reordered successfully");
    } catch (error) {
      const oldItems = data.cancelAction();
      thunkAPI.dispatch(reorderMissions(oldItems.map((item) => item.id)));

      showNetworkErrorToast(error);
      return Promise.reject();
    }
  }
);
